module.exports = __webpack_public_path__ + "static/media/Daffodil-WIFI-Logo.a754ead6.png";